<template>
  <v-card class="import-rbu-section-template">
    <v-card-title class="justify-center">
      {{ $t("rbu_section.import_template_title") }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-row no-gutters>
          <v-col cols="3" class="input-label"
            >{{ $t("rbu_section.template_excel") }}
          </v-col>
          <v-col cols="9">
            <FileInput
              v-model="excelFile"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              :rules="requiredRules"
            ></FileInput>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && checkExcel()"
        depressed
        large
      >
        {{ $t("save") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import FileInput from "@/components/FileInput";
import ImportRbuSectionTemplateWarningDialog from "@/components/rbu/ImportRbuSectionTemplateWarningDialog";

export default {
  name: "ImportRbuSectionTemplateDialog",
  components: { FileInput },
  props: {
    sectionId: String,
  },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);

    const excelFile = ref(null);

    const confirm = async function () {
      let formData = new FormData();
      formData.append("section_id", props.sectionId);
      formData.append("excel", excelFile.value, excelFile.value.name);

      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/upload_template/",
        params: formData,
      });

      if (response.body.success) {
        emit("submit", true);
      }
    };

    const checkExcel = async function () {
      let formData = new FormData();
      formData.append("section_id", props.sectionId);
      formData.append("excel", excelFile.value, excelFile.value.name);

      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/check_template/",
        params: formData,
      });

      if (response && response.data && response.data.success) {
        if (response.data.valid) {
          confirm();
        } else {
          // warn
          const keepGoing = await root.$dialog.showAndWait(
            ImportRbuSectionTemplateWarningDialog,
            {
              showClose: true,
              persistent: false,
              msg: response.data.msg,
            }
          );

          if (keepGoing) {
            confirm();
          }
        }
      }
    };

    return {
      requiredRules,

      excelFile,

      confirm,
      checkExcel,
    };
  },
};
</script>

<style lang="less">
.import-rbu-section-template {
  .input-label {
    text-align: right;
    padding: 4px 16px 0 0 !important;
  }
}
</style>
